import { Component } from '@angular/core';
import { coolBeans } from '../environments/environment';
import { ConsoleToggleService } from './services/console-toggle.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  coolBeans;
  constructor(private consoleToggleService : ConsoleToggleService) {
    this.coolBeans = coolBeans;
    this.consoleToggleService.disableConsoleWhenNotDemo();
  }

}
